import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureAccessService } from './feature-access.service';

/**
 * Reconciliation Review is a top-level sidebar entry
 * (tblPage:ReconciliationReview, Link='savings-reconciliation-review').
 * Route is declared top-level in app.routes.ts so the sidebar's routeToLink
 * call resolves against the same string the DB Link stores.
 * Tenant gate = tblPage.Status via the SideBar cache. Per-user gate (Finance
 * persona) is enforced inside the component via RBAC `savings.approve`; this
 * guard only prevents non-licensed tenants from reaching the route.
 */
export const reconciliationReviewGuard: CanActivateFn = () => {
  const featureAccess = inject(FeatureAccessService);
  const router = inject(Router);
  if (featureAccess.isPageActive('savings-reconciliation-review')) return true;
  router.navigateByUrl('dashboard');
  return false;
};
